// extracted by mini-css-extract-plugin
module.exports = {"fieldSet":"FieldSet-fieldSet-2WQZt","legend":"FieldSet-legend-3x6NF"};